
import apiURL from './apiURL';
// const apiURL = "http://localhost:3000"

// const orgId = window.location.pathname == '/xero/callback/' ? window.localStorage.getItem('organisation') : window.location.pathname.split('/')[2];

// types of action
const Types = {
  DEPARTMENTS_GET_LIST: "DEPARTMENTS_GET_LIST",
  DEPARTMENTS_UPDATE: "DEPARTMENTS_UPDATE",
  DEPARTMENTS_SAVE: "DEPARTMENTS_SAVE",
  DEPARTMENTS_ADD: "DEPARTMENTS_ADD",
  DEPARTMENTS_REMOVE: "DEPARTMENTS_REMOVE",
};

const removeDepartment = (id) => ({
  type: Types.DEPARTMENTS_REMOVE,
  id
});

const addDepartment = (parent, data) => ({
  type: Types.DEPARTMENTS_ADD,
  parent,
  data
});

const updateDepartment = (id,field,newValue) => ({
  type: Types.DEPARTMENTS_UPDATE,
  id,
  field,
  newValue
});

const departmentUpdateList = response => ({
  type: Types.DEPARTMENTS_GET_LIST,
  payload: response
});

const departmentGetList = () => {
  // department list now in company settings
  return;
  return (dispatch, getState) => {

    fetch(apiURL + `/settings/departments` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(departmentUpdateList(data))
    })
  }
}

const departmentsSaved = response => ({
  type: Types.DEPARTMENTS_SAVE,
  payload: response
});

const saveDepartments = () => {
  return (dispatch, getState) => {

    const state = getState()

    const departments = state.company?.settings?.departments

    console.log('departments',departments)

    fetch(apiURL + `/settings/departments` , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({departments}),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(departmentsSaved(data))
    })
  }
}

const Actions = {
  departmentGetList,
  updateDepartment,
  addDepartment,
  removeDepartment,
  saveDepartments,
}

// exports = {
//   Types,
//   Actions
// }

export { Actions, Types };

// exports.Types = Types
// exports.Actions = Actions